
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
import { CustomerOrderDto } from "@/dtos/customerOrderDto";
import { ErpCustomerOrderState } from "@/dtos/erpCustomerOrderState";

@Component
export default class EditTransportDialog extends Vue {
	@Prop()
	private open!: boolean;
	@Prop()
	private order!: CustomerOrderDto;
	private loading: boolean = false;
	private transportProviderId: number | null = 0;
	private transportProviders: Array<{ id: number; name: string }> = [];
	private selectedTransportProviderId: number | null = null;
	private updateTransportCostForCustomer: boolean = false;
	private newTransportCostTotal: number = 0;
	private fertigerWrappingCompensation: number = 0;
	private isTransportFormValid: boolean = true;
	private isUpdateCostLocked: boolean = false;
	private transportCostRules = [
		(v: any) => v !== "" || "Kosten müssen angegeben werden.",
		(v: any) => !isNaN(v) || "Bitte Zahl eingeben",
		(v: any) => v >= 0 || "Anzahl muss grösser oder gleich 0 sein",
	];

	@Watch("open")
	private onOpenChanged() {
		if (this.open) {
			this.loadOrderInfo();
			(this.$refs.form as any).validate();
		}
	}

	private close(reload: boolean) {
		this.$emit("close", reload);
	}

	private async loadOrderInfo() {
		try {
			this.loading = true;
			const transportProviderResponse = await httpClient().get(
				`CustomerOrder/GetTransportProviders?regionId=${this.order.regionId}`
			);
			this.transportProviders = transportProviderResponse.data;
			this.transportProviders.push({
				id: 0,
				name: "Rampenabholung",
			});
			this.transportProviderId = this.order.transportProviderId;
			this.selectedTransportProviderId = this.order.transportProviderId;
			const transportResponse = await httpClient().get(
				`CustomerOrder/GetModifyTransportData?orderId=${this.order.orderId}`
			);
			this.isUpdateCostLocked = false;
			if (transportResponse.data.transportCostSetManually) {
				// If the cost was ever set manually, the checkbox can't be unchecked anymore.
				// But the actual cost can still be modified.
				this.isUpdateCostLocked = true;
			}
			this.updateTransportCostForCustomer = transportResponse.data.transportCostSetManually;
			this.newTransportCostTotal = transportResponse.data.customerTransportCostOverride;
			this.fertigerWrappingCompensation = transportResponse.data.fertigerWrappingOverride;
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Transportinformationen."
			);
			this.close(false);
		} finally {
			this.loading = false;
		}
	}

	private getTransportProviders() {
		if (!this.transportProviders.length) return [];
		return this.transportProviders;
	}

	private async modifyTransport() {
		try {
			this.loading = true;
			await httpClient().post(
				`CustomerOrder/SetTransportProvider?fertigerId=${this.order!.fertigerId}` +
					`&customerOrderId=${this.order!.orderId}` +
					`&transportProviderId=${this.selectedTransportProviderId}` +
					`&updateTransportCostForCustomer=${this.updateTransportCostForCustomer}` +
					`&newTransportCostTotal=${this.newTransportCostTotal}` +
					`&fertigerWrappingCompensation=${this.fertigerWrappingCompensation}`
			);
			this.order!.transportProviderId = this.selectedTransportProviderId;
			this.$store.commit("setSnackbarText", "Transport wurde geändert.");
			this.close(true);
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Ändern des Transports.");
		} finally {
			this.loading = false;
		}
	}

	private get willProviderBeChanged() {
		return (
			this.selectedTransportProviderId &&
			this.selectedTransportProviderId !== this.transportProviderId
		);
	}

	private get isModifyTransportValid() {
		if (
			this.selectedTransportProviderId === null ||
			this.selectedTransportProviderId === undefined
		)
			return false;
		if (!this.isTransportFormValid) return false;
		return (
			this.selectedTransportProviderId !== this.transportProviderId ||
			this.updateTransportCostForCustomer
		);
	}
}
